import styled, { css } from 'styled-components'

export const Wrapper = styled.header`
  ${({ theme }) => css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
    padding: 10px 24px;
    height: 72px;
    width: 100%;
    z-index: ${theme.layers.base};
    background-color: ${theme.ds.colors.white};
    border-bottom: 1px solid #c4c4c4;
  `}
`

export const Content = styled.div`
  padding-left: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;

  h5 {
    color: ${({ theme }) => theme.colors?.primary};
    font-size: ${({ theme }) => theme.font?.sizes.medium};
    font-weight: 600;
  }

  select {
    margin: 0;
    color: ${({ theme }) => theme.colors?.primary};
    font-weight: ${({ theme }) => theme.font?.bold};
  }
`

export const UserWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 32px;
`

export const LogoWrapper = styled.div`
  margin-right: 8px;
  margin-left: 8px;
`

export const UserInfo = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: flex-end;
  margin-right: 24px;

  strong {
    font-weight: 600;
    font-size: ${({ theme }) => theme.font?.sizes.medium};
    color: ${({ theme }) => theme.colors?.primary};
  }

  label {
    font-weight: 600;
    font-size: ${({ theme }) => theme.font?.sizes.small};
    color: ${({ theme }) => theme.colors?.lightGray};
  }
`

export const NewSurgicalOrder = styled.div`
  background: ${({ theme }) => theme.colors.secondary};
  border-radius: 8px;
  height: 48px;
  padding: 0px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  margin-left: 1rem;
  margin-left: auto;

  span {
    font-weight: 600;
    font-size: 18px;
    color: white;
  }
`

export const HeaderButton = styled.div`
  background: ${({ theme }) => theme.colors.secondary};
  border-radius: 8px;
  height: 48px;
  padding: 0px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  min-width: 235px;
  margin-left: auto;

  span {
    font-weight: 600;
    font-size: 18px;
    color: white;
  }
`

export const AddButton = styled.div`
  background: ${({ theme }) => theme.colors.secondary};
  border-radius: 10px;
  height: 37px;
  width: 37px;
  padding: 0px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-right: 1rem;

  span {
    font-weight: 600;
    font-size: 18px;
    color: white;
  }
`

export const Options = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`

export const IconWrapper = styled.div`
  min-width: 54px;
  display: flex;
  align-items: center;

  svg {
    cursor: pointer;
    font-size: 32px;
    color: #a0a49f;
  }
`
